import { useState } from "react";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import { FAQS } from "../data/content";

export const Faq = () => {
  const [open, setOpen] = useState(-1);

  return (
    <section className="section" id="faq" data-testid="faq-section">
      <div className="wrap">
        <Reveal className="section-head">
          <span className="eyebrow"><span className="sq" /> FAQ</span>
          <h2 data-testid="faq-heading">Frequently asked questions</h2>
        </Reveal>

        <div className="case-list">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={i * 40}>
                <div className={`case-card faq-card ${isOpen ? "open" : ""}`} data-testid={`faq-card-${i}`}>
                  <button
                    className="case-head"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    data-testid={`faq-toggle-${i}`}
                  >
                    <div className="left">
                      <span className="idx">{String(i + 1).padStart(2, "0")}</span>
                      <div>
                        <h3 className="faq-q">{f.q}</h3>
                      </div>
                    </div>
                    <span className="plus"><Plus size={22} strokeWidth={2.5} /></span>
                  </button>
                  <div className="case-body">
                    <div className="case-body-clip">
                      <div className="case-body-inner faq-answer">
                        <p>{f.a}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
